module.exports = __webpack_public_path__ + "static/18-5dc8e229a892be37345c5259cd71ca71.jpg";